import Vue from 'vue'

export function randomInt(min, max) {
  if (max == null)
    [min, max] = [0, min]

  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min)) + min;
}

export function randomId() {
  return Math.random().toString(36).substring(2, 15)
}

export function randomChoice(arr) {
  return arr[randomInt(arr.length)]
}

export function delay(ms) {
  return new Promise(resolve => setTimeout(() => resolve(), ms))
}

export function isObject(x) {
  return typeof x === 'object' && x !== null
}

export function vueObjectAssign(target, source) {
  for (let prop in source) {
    if (target[prop] != null)
      continue
    
    var def = source[prop]
    if (Array.isArray(def))
      def = [...def]
    
    Vue.set(target, prop, def)
  }
}

export function prefGet(key, defaultValue) {
  const json = localStorage.getItem(`__pref__${key}`)
  return json ? JSON.parse(json) : defaultValue
}

export function prefSet(key, value) {
  const json = JSON.stringify(value)
  localStorage.setItem(`__pref__${key}`, json)
}

export function commaify(n) {
  return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function pluralize({ n, singular, plural, includeN, blankIfZero }) {
  if (blankIfZero && n === 0)
    return ''

  const preWord = includeN ? `${commaify(n)} ` : ''
  const word = n > 1 ? (plural || `${singular}s`) : singular
  return preWord + word
}

export function fbMemberName(member) {
  let name = member.name != null
    ? member.name
    : `${member.firstName} ${member.lastName}`
  return name.trim() || '(blank)'
}

export function fbCommentLikeCount(comment) {
  const {
    likeCount = 0, 
    likeable = true, 
    liked = false
  } = comment || {}
  return likeCount + +(likeable && liked)
}